import Component from '../component';

export default class Weezevent extends Component {
    constructor(...args) {
        super(...args);

        this._pageYOffset = 0;

        this._retriveDOM();
    }

    _retriveDOM() {
        this.dom.close = this.dom.component.querySelector('.js-close-iframe');
    }

    bind() {
        this.dom.close.addEventListener('click', this.closeIframe.bind(this));
    }

    openIframe() {
        this._pageYOffset = window.pageYOffset;
        document.body.classList.add('no-scroll');
        this.dom.component.classList.add('show');
    }

    closeIframe() {
        document.body.classList.remove('no-scroll');
        window.scroll({top: this._pageYOffset, left: 0 });
        this.dom.component.classList.remove('show');
    }
    /*
    init() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/weezevent/weezevent.js